import CustomerCaseStore from './CustomerCaseStore';
import FormDataStore from './FormDataStore';
import LanguageStore from './LanguageStore';

class RootStore {
  constructor() {
    this.customerCaseStore = new CustomerCaseStore();
    this.formDataStore = new FormDataStore();
    this.languageStore = new LanguageStore();
  }
}

const rootStore = (window.store = new RootStore());

export default rootStore;



// WEBPACK FOOTER //
// ./src/store/index.js